// extracted by mini-css-extract-plugin
module.exports = {"tips-example":"TipsExample_tips-example__7KkjR","tips-example__title":"TipsExample_tips-example__title__ITnXh"};